var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9759 7.6665C10.2821 7.6665 1.9165 14.3282 1.9165 22.5485C1.9165 30.7669 10.2821 37.4296 22.9759 37.4296C35.6716 37.4296 44.0392 30.7669 44.0392 22.5485C44.0392 14.3282 35.6716 7.6665 22.9759 7.6665Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7292 28.1094C30.3453 27.4817 42.5557 24.9689 41.0513 18.0011C40.5098 15.5019 37.9389 12.7527 34.0602 10.8415C30.9604 9.44655 27.1767 8.63672 22.9271 8.63672C11.1419 8.63672 2.94678 14.8645 2.94678 22.5481C2.94678 27.8992 6.9252 32.545 13.3225 34.8699C14.6796 31.2974 20.0849 29.2621 26.7292 28.1094Z",
    fill: "#0075C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0019 30.5738C17.7176 31.2373 15.293 32.9442 13.7344 35.0172C16.4273 35.9384 19.5262 36.4576 22.9263 36.4576C34.7124 36.4576 42.9076 30.2318 42.9076 22.5482C42.9076 21.8672 42.8427 21.1978 42.7167 20.543C42.3263 29.5644 28.784 29.856 23.0019 30.5738Z",
    fill: "url(#paint0_linear_1603_28830)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8766 26.34C27.8175 25.6871 27.7933 25.2415 27.7933 24.8579V20.9599H25.916L25.976 21.08C25.978 21.0829 26.1669 21.4568 26.1669 22.2744L26.1669 22.2814C26.1672 22.4353 26.1718 24.9988 26.0981 25.6183C25.6448 25.7346 25.0383 25.7762 24.6451 25.7762C21.6663 25.7762 20.1542 24.0655 20.1542 20.6954C20.1542 18.1226 21.8562 16.2017 24.2915 16.0254C25.5731 15.9343 26.8062 16.283 27.5831 16.9573L27.7187 17.0754V15.5003L27.6538 15.4877C26.8798 15.3386 25.9712 15.1816 25.0819 15.1816C20.7935 15.1816 18.2313 17.4397 18.2313 21.2205C18.2313 25.2483 21.3593 26.6829 24.2876 26.6829C25.5285 26.6829 26.812 26.5909 27.8088 26.4272L27.8834 26.4146L27.8766 26.34ZM9.48919 16.2803C9.71683 16.261 10.4143 16.2106 10.919 16.2106C13.9365 16.2106 15.344 17.6733 15.344 20.8148C15.344 24.0609 14.0934 25.6408 11.5234 25.6408C9.64224 25.6408 9.48919 25.5498 9.48919 24.4348V16.2803ZM11.5543 15.2845H7.60205L7.64855 15.3978C7.82388 15.824 7.81323 16.6009 7.8016 17.2887C7.79676 17.4505 7.79482 26.4128 7.79482 26.4128L7.87329 26.4148C7.89169 26.4167 9.67409 26.4806 11.3635 26.4806C14.8934 26.4806 17.2657 24.0879 17.2657 20.527C17.2657 17.342 15.0242 15.2845 11.5543 15.2845ZM32.5801 16.1579H31.4758L31.47 19.9716H32.1907C34.1475 19.9716 35.059 19.3187 35.059 17.916C35.059 16.6839 34.3199 16.1579 32.5801 16.1579ZM32.3419 20.8454H31.47V24.512C31.47 25.3237 31.8129 25.6405 32.6896 25.6405C34.4982 25.6405 35.3777 24.8403 35.3777 23.1955C35.3777 21.6359 34.3587 20.8454 32.3419 20.8454ZM36.6768 17.6894C36.6768 19.0707 35.65 20.0171 34.5767 20.3029C36.1953 20.6497 37.2967 21.7647 37.2967 23.0957C37.2967 25.2462 35.6674 26.4803 32.8262 26.4803C31.3322 26.4803 30.1025 26.5022 29.897 26.5059C29.8782 26.5062 29.868 26.5064 29.8669 26.5064L29.7836 26.5084V16.8582C29.7836 15.8324 29.6857 15.3887 29.6838 15.3839L29.6615 15.2841H33.0422C35.3196 15.2841 36.6768 16.1821 36.6768 17.6894Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1603_28830",
    x1: 44.4653,
    y1: 25.177,
    x2: 14.8985,
    y2: 27.1142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AB935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305922,
    stopColor: "#00A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669783,
    stopColor: "#008AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/하이투자증권-46.5df37c6087f1b8186ba50203b5263aba.svg";
export { ForwardRef as ReactComponent };